<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import NervenetFrame from './NervenetFrame.vue';

const { accountId } = useAccount();

const knowledgeUrl = computed(
  () =>
    `${window.chatwootConfig.nervenetBaseUrl}/accounts/${accountId.value}/agent/knowledge`
);
</script>

<template>
  <NervenetFrame :src="knowledgeUrl" />
</template>
